import { Device } from '../interfaces/api';

/**
 * Get device with id
 */
export const getDeviceWithId = (devices: Device[], deviceId: string): Device | null => {
    return devices.find(device => device.id === deviceId) || null;
};
